export const REASSIGN = 'REASSIGN'
export const REASSIGN_PENDING = 'REASSIGN_PENDING'
export const REASSIGN_FULFILLED = 'REASSIGN_FULFILLED'
export const REASSIGN_REJECTED = 'REASSIGN_REJECTED'

export const REASSIGN_TO_JOB = 'REASSIGN_TO_JOB'
export const REASSIGN_TO_JOB_PENDING = 'REASSIGN_TO_JOB_PENDING'
export const REASSIGN_TO_JOB_FULFILLED = 'REASSIGN_TO_JOB_FULFILLED'
export const REASSIGN_TO_JOB_REJECTED = 'REASSIGN_TO_JOB_REJECTED'

export const UNASSIGN = 'UNASSIGN'
export const UNASSIGN_PENDING = 'UNASSIGN_PENDING'
export const UNASSIGN_FULFILLED = 'UNASSIGN_FULFILLED'
export const UNASSIGN_REJECTED = 'UNASSIGN_REJECTED'

export type UnAssignRequest = {
  job_application_ids: string[]
}

export type UnAssignResponse = {
  data: {
    message: string
  }
  success: boolean
  status_code: number
}

export type ReAssignRequest = {
  new_job_workflow_stage_id: string
  job_application_ids: string[]
}

export type ReAssignResponse = {
  data: {
    message: string
  }
  success: boolean
  statusCode: number
}

export type ReAssignToJobRequest = {
  new_job_id: string
  job_application_ids: string[]
}

export type ReAssignToJobResponse = {
  data: {
    message: string
  }
  success: boolean
  statusCode: number
}
